document.addEventListener('DOMContentLoaded', function () {
  const spans = document.querySelectorAll('span')
  spans.forEach((span) => {
    span.innerHTML = span.innerHTML.trim()
  })
})
